module.exports = __webpack_public_path__ + "static/media/dz.0ffabba4.svg";